<template>
  <div class="w-full overflow-hidden pt-1" v-on="$listeners">
    <div class="w-full flex flex-row">
      <!-- Planning service -->
      <div class="w-1/2 flex flex-col md:flex-row p-1">
        <template v-if="productPlanning">
          <div class="w-full md:w-1/3">
            <div class="w-56 flex items-center justify-center cursor-pointer" @click="navigate_to_detail_view(productPlanning.id)">
              <img :src="productPlanning.image" :alt="productPlanningLang.name" class="h-16">
            </div>
          </div>

          <div class="w-full md:w-2/3 flex flex-col">
            <p class="w-full mr-1 truncate text-primary text-xs md:text-base font-bold">
              {{ productPlanning.code | concat('-') | concat(productPlanningLang.name) }}
            </p>

            <div class="w-full flex justify-start">
              <h6 class="font-bold" v-if="$store.state.Profile.isBRL()">{{ productPlanning.price | BRL }}</h6>
              <h6 class="font-bold" v-else-if="$store.state.Profile.isUSD()">{{ productPlanning.price | USD }}</h6>
              <h6 v-else>ERRO</h6>
            </div>

            <!-- Print option -->
            <div class="w-full flex justify-start" v-if="enableSwitchManufacturer">
              <vs-switch class="border border-gray-600" color="primary" v-model="printSwitcher"/>
              <bds-label :text-help="$t('pages.shop.checkout.tab1.serviceBox.bdsWillPrintHelp')">
                <span class="font-bold text-sm">{{ $t('pages.shop.checkout.tab1.serviceBox.bdsWillPrint') }}</span>
              </bds-label>
            </div>
          </div>
        </template>
      </div>

      <!-- Manufacture service -->
      <div class="w-1/2 flex flex-col md:flex-row p-1">
        <template v-if="productManufacture">
          <v-select :options="serviceManufactureOptions" label="code" v-model="productManufacture" :reduce="s => s"
                    :appendToBody="true" class="w-full mx-2" :clearable="false" :searchable="false" :filterable="false"
                    :disabled="serviceManufactureOptions.length <= 1">

            <template #option="option">
              <div class="w-full flex flex-row">
                <div class="w-2/3 flex flex-col">
                  <p class="w-full mr-1 truncate text-xs md:text-base font-bold">
                    {{ option.code | concat('-') | concat(serviceLang(option).name) }}
                  </p>

                  <div class="w-full flex justify-start">
                    <h6 class="font-bold" v-if="$store.state.Profile.isBRL()">{{ option.price | BRL }}</h6>
                    <h6 class="font-bold" v-else-if="$store.state.Profile.isUSD()">{{ option.price | USD }}</h6>
                    <h6 v-else>ERRO</h6>
                  </div>

                  <!--                <checkout-surgical-kit class="w-full flex flex-row justify-between items-center"-->
                  <!--                                       :product-checkout="productCheckout" v-if="isKitEnabledOnManufactureService(option)"/>-->
                  <!--                <checkout-sleeve-box class="w-full flex flex-row justify-between items-center"-->
                  <!--                                     :product-checkout="productCheckout" v-if="isSleevesEnabledOnManufactureService(option)"/>-->
                </div>
                <div class="w-1/3">
                  <div class="h-56 flex items-center justify-center cursor-pointer">
                    <img :src="option.image" :alt="serviceLang(option).name" class="h-16">
                  </div>
                </div>
              </div>
            </template>

            <template #selected-option="option">
              <div class="w-full flex flex-row">
                <div class="w-2/3 flex flex-col">
                  <p class="w-full mr-1 truncate text-primary text-xs md:text-base font-bold">
                    {{ option.code | concat('-') | concat(serviceLang(option).name) }}
                  </p>

                  <div class="w-full flex justify-start">
                    <h6 class="font-bold" v-if="$store.state.Profile.isBRL()">{{ option.price | BRL }}</h6>
                    <h6 class="font-bold" v-else-if="$store.state.Profile.isUSD()">{{ option.price | USD }}</h6>
                    <h6 v-else>ERRO</h6>
                  </div>

<!--                  <checkout-surgical-kit class="w-full flex flex-row justify-between items-center"-->
<!--                                         :product-checkout="productCheckout" v-if="isKitEnabledOnManufactureService(option)"/>-->
<!--                  <checkout-sleeve-box class="w-full flex flex-row justify-between items-center"-->
<!--                                       :product-checkout="productCheckout" v-if="isSleevesEnabledOnManufactureService(option)"/>-->
                </div>
                <div class="md:w-1/3">
                  <div class="h-56 flex items-center justify-center cursor-pointer">
                    <img :src="option.image" :alt="serviceLang(option).name" class="h-16">
                  </div>
                </div>
              </div>
            </template>
          </v-select>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {ProductShopCheckout} from "@/models/Product.model";
// import CheckoutSleeveBox from "@/views/ecommerce/components/CheckoutSleeveBox";
// import CheckoutSurgicalKit from "@/views/ecommerce/components/CheckoutSurgicalKit";

  /**
   * Component responsible to render each planning service and his manufacture (if needed)
   */
  export default {
    name: 'CheckoutGridProduct',
    components: {
      // CheckoutSleeveBox,
      // CheckoutSurgicalKit
    },
    props: {
      productCheckout: {
        type: ProductShopCheckout,
        required: true
      },
    },
    data() {
      return {

      }
    },
    computed: {
      productPlanning() {
        if (!this.productCheckout.productPlanningId) {
          return null;
        }
        const product_model = this.$store.getters['Shop/getProductByIdFromShop'](this.productCheckout.productPlanningId);
        return product_model;
      },
      productPlanningLang() {
        const locale = this.$i18n.locale;
        return this.productPlanning[locale];
      },
      productManufacture: {
        get() {
          if (!this.productCheckout.productManufactureId) {
            return null;
          }
          const manufacture_model = this.$store.getters['Shop/getProductByIdFromShop'](this.productCheckout.productManufactureId);
          return manufacture_model;
        },
        set(val) {
          this.$store.commit('Shop/UPDATE_PRODUCT_CHECKOUT',
            { checkoutProduct: this.productCheckout, manufactureService: val.id });
        }
      },
      serviceManufactureOptions() {
        let options = [];
        if (!this.productPlanning) {
          return options;
        }

        for (let service_manufacture of this.productPlanning.innerProducts) {
          options.push(this.$store.getters['Shop/getProductByIdFromShop'](service_manufacture));
        }
        return options;
      },
      enableSwitchManufacturer() {
        let ret = true;
        if (this.productCheckout.productPlanningId) {
          const service_ = this.$store.getters['Shop/getProductByIdFromShop'](this.productCheckout.productPlanningId);
          if (service_) {
            ret = ret && !!service_ && service_.canBeManufactureByDoctor();
          } else {
            ret = false;
          }
        }

        if (this.productCheckout.productManufactureId) {
          const product_ = this.$store.getters['Shop/getProductByIdFromShop'](this.productCheckout.productManufactureId);
          if (product_) {
            ret = ret && !!product_;
          } else {
            ret = false;
          }
        } else if (this.productPlanning && this.productPlanning.innerProducts.length > 0) {
          const product_ = this.$store.getters['Shop/getProductByIdFromShop'](this.productPlanning.innerProducts[0]);
          if (product_) {
            ret = ret && !!product_;
          } else {
            ret = false;
          }
        }

        return ret;
      },
      printSwitcher: {
        get() {
          if (this.enableSwitchManufacturer && this.productCheckout.productManufactureId) {
            return true;
          }

          return false;
        },
        set(val) {
          let selectedManufacturer = 0;
          if (val) {
            selectedManufacturer = this.productPlanning.innerProducts[0];
          }
          this.$store.commit('Shop/UPDATE_PRODUCT_CHECKOUT',
            { checkoutProduct: this.productCheckout, manufactureService: selectedManufacturer });
        }
      },
    },
    methods: {
      navigate_to_detail_view(product_id) {
        this.$router.push({ name: 'shop-item', params: { item_id: product_id } });
      },

      serviceLang(service) {
        const locale = this.$i18n.locale;
        return service[locale];
      },

      isKitEnabledOnManufactureService(service) {
        return service.enableKit || false;
      },
      isSleevesEnabledOnManufactureService(service) {
        return service.enableSleeve || false;
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .vs__selected-options {
    .vs__selected {
      width: 100%
    }

    input.vs__search {
      display: none;
    }
  }
</style>
